export const INITIALIZE_SUCCESS = 'INITIALIZE_SUCCESS';
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';
export const SET_LAST_BREADCRUMBS = 'SET_LAST_BREADCRUMBS';
export const PUSH_BREADCRUMBS = 'PUSH_BREADCRUMBS';
export const SET_PAGE_HEAD = 'SET_PAGE_HEAD';
